module.exports = __webpack_public_path__ + "static/media/2.6a6e4f42.svg";